const OrderItemPlaceHolder = () => {
    return (
        <div className='ui card fluid' style={{position: 'relative', overflow: 'hidden'}}>
            <div className="ui placeholder fluid">
                <div className="header">
                    <div className="line"></div>
                    <div className="line"></div>
                </div>
                <div className="paragraph">
                    <div className="line"></div>
                    <div className="line"></div>
                    <div className="line"></div>
                    <div className="line"></div>
                    <div className="line"></div>
                </div>
            </div>
        </div>
    )
}

export default OrderItemPlaceHolder